export default "__VITE_PUBLIC_ASSET__48ff080a__"